export const normalizeFetchLmsQuestionsResponse = response => {
    const normalizedLmsQuestions = response.lms_questions.map(lmsQuestion => ({
        id: lmsQuestion.id,
        content: lmsQuestion.description,
        description: lmsQuestion.long_description,
        categories: lmsQuestion.patterns.map(pattern => ({
            id: pattern.id,
            name: pattern.description,
            description: pattern.long_description,
        })),
    }))

    const combinedData = response.questions.map(question => {
        const combinedCategories = question.patterns.map(pattern => ({
            lmsId: pattern.lms_pattern_id === 'blank' ? null : pattern.lms_pattern_id,
            ...pattern,
        }))

        return {
            lmsId: question.lms_criterion_id === 'blank' ? null : question.lms_criterion_id,
            categories: combinedCategories,
            ...question,
        }
    })

    return {
        questionsEnrichedWithLms: combinedData.filter(Boolean),
        lmsQuestions: normalizedLmsQuestions,
    }
}

export const normalizeFetchLmsConfigResponse = lmsConfig => ({
    organizationId: lmsConfig.account_id,
    lmsUrl: lmsConfig.lms_url,
    token: lmsConfig.token,
})

export const normalizeFetchLmsConfigsResponse = response => response.map(normalizeFetchLmsConfigResponse)

export const denormalizeUpdateLmsQuestionsRelationshipsPayload = payload =>
    payload.map(question => ({
        id: question.id,
        lms_criterion_id: question.lmsId,
        patterns: question.categories.map(category => ({
            id: category.id,
            lms_rating_id: category.lmsId,
        })),
    }))
